<template>
    <MainComponent :id="anchorsPageProfile.aboutSection">
        <template #title>
            <h2>{{ sectionTitle }}</h2>
        </template>
        <template #title-action>
            <ClientOnly v-if="isEditionEnabled">
                <VJoyIconButton
                    icon="pencil"
                    size="small"
                    variant="ghost"
                    :label="$t('general.edit')"
                    data-testid="profile-about-edit-cta"
                    @click="editAboutSection"
                />
                <template #fallback>
                    <SectionActionSkeleton />
                </template>
            </ClientOnly>
        </template>
        <template #content>
            <AboutSectionCommon>
                <template #description-empty-state>
                    <div class="profile-about-section__empty-state-placeholder" data-testid="profile-description-empty-state">
                        <VJoyIcon size="xsmall" name="info-circle" color="neutral" />
                        {{ $t('profile.section.about.empty.state.placeholder.description') }}
                    </div>
                </template>
                <template #industry-expertises-empty-state>
                    <div class="profile-about-section__empty-state-placeholder" data-testId="profile-about-section__industry-expertises-empty-state">
                        <VJoyIcon size="xsmall" name="info-circle" color="neutral" />
                        {{ $t('profile.section.about.empty.state.placeholder.industry.expertises') }}
                    </div>
                </template>
                <template #languages-empty-state>
                    <div class="profile-about-section__empty-state-placeholder" data-testId="profile-about-section__languages-empty-state">
                        <VJoyIcon size="xsmall" name="info-circle" color="neutral" />
                        {{ $t('profile.section.about.empty.state.placeholder.languages') }}
                    </div>
                </template>
            </AboutSectionCommon>
        </template>
    </MainComponent>
    <LazyEditAboutSection />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useProfilePageViewMode, useTranslation} from '#imports';
    import {VJoyIconButton, VJoyIcon} from '@maltjoy/core-vue';
    import MainComponent from '~/components/main/common/MainComponent.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';
    import AboutSectionCommon from '~/features/about/ui/AboutSectionCommon.vue';
    import LazyEditAboutSection from '~/features/about/ui/edit/EditAboutSection.vue';
    import {useProfileStore} from '~/store/profileStore';

    const {profile} = storeToRefs(useProfileStore());

    // Composables
    const {t} = useTranslation();
    const {isEditionEnabled} = useProfilePageViewMode();

    // Computed values
    const sectionTitle = computed(() =>
        profile.value?.editMode ? t('profile.section.about.title.self') : t('profile.section.about.title', {0: profile.value?.firstname}),
    );

    function editAboutSection() {
        eventBus.emit('about:edit-mode', {entryPoint: EditionOpenedEntryPoint.PROFILE_PAGE});
    }
</script>
<style scoped lang="scss">
    .profile-about-section {
        &__empty-state-placeholder {
            align-items: center;
            display: flex;
            column-gap: var(--joy-core-spacing-2);
            color: var(--joy-color-neutral-40);
        }
    }
</style>
